document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-behavior~=copy-button]").forEach(function (button) {
    button.addEventListener("click", function () {
      var target = document.querySelector("[data-button-target~=" + button.dataset.target + "]");
      target.select();
      document.execCommand("copy");
      alert("Link copied!");
    });
  });

  document.querySelectorAll("[data-behavior~=link-select]").forEach(function (select) {
    select.addEventListener("change", function () {
      var target = document.querySelector("[data-select-target~=" + select.dataset.target + "]");
      target.value = select.value;
    });
  });
});
